var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m24 19.12-.029-17.037L21.918.03 4.88 0l4.537 4.537 6.735-.057L1 19.633 4.367 23 19.52 7.847l-.057 6.735L24 19.119Z"
})));
export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJtMjQgMTkuMTItLjAyOS0xNy4wMzdMMjEuOTE4LjAzIDQuODggMGw0LjUzNyA0LjUzNyA2LjczNS0uMDU3TDEgMTkuNjMzIDQuMzY3IDIzIDE5LjUyIDcuODQ3bC0uMDU3IDYuNzM1TDI0IDE5LjExOVoiLz4KPC9zdmc+";